import { toast } from "sonner";
import { NAME } from "./contact";

export const shareCard = async () => {
    const payload = {
        title: `${NAME} — Biglietto digitale`,
        text: `Il biglietto da visita digitale di ${NAME}`,
        url: window.location.href,
    };
    try {
        if (navigator.share) {
            await navigator.share(payload);
        } else {
            await navigator.clipboard.writeText(window.location.href);
            toast.success("Link copiato", { description: "Incollalo dove vuoi: WhatsApp, email, social." });
        }
    } catch {
        /* condivisione annullata */
    }
};
